import { productsService } from '@/services';
import { useQuery } from '@tanstack/react-query';

/**
 * Catálogo de produtos do InsureMO — a lista que pode ser vinculada a uma
 * corretora.
 *
 * Não confundir com `app/config/products.config.ts`: aquele é o registry
 * hardcoded dos wizards de cotação e não enxerga produto novo cadastrado no
 * InsureMO.
 */
export function useProductsCatalog(enabled = true) {
  return useQuery({
    queryKey: ['products-catalog'],
    queryFn: async () => {
      const response = await productsService.list();

      if (!response.success || !response.data) {
        throw new Error(response.error ?? 'Erro ao carregar produtos');
      }

      return response.data;
    },
    enabled,
    // O catálogo não muda dentro de uma sessão.
    staleTime: 1000 * 60 * 30,
  });
}
